// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentArea_FiMYL {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container_E6KkM {
  gap: var( --size-padXXLarge );
}

.billingIconContainer_PN3z_ {
  overflow: hidden;
}

.billingIcon_GtaLk {
  max-width: 100%;
  height: auto;
}

.description_outkt {
  gap: var( --size-medium );
  max-width: 50%;
}

.buttonContainer_T1dTJ {
  margin-top: var( --size-large );
}

@media (max-width: 430px) {
  .description_outkt {
    gap: var( --size-medium );
    max-width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/billingPortal/BillingPortalScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF","sourcesContent":[".contentArea {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.container {\n  gap: var( --size-padXXLarge );\n}\n\n.billingIconContainer {\n  overflow: hidden;\n}\n\n.billingIcon {\n  max-width: 100%;\n  height: auto;\n}\n\n.description {\n  gap: var( --size-medium );\n  max-width: 50%;\n}\n\n.buttonContainer {\n  margin-top: var( --size-large );\n}\n\n@media (max-width: 430px) {\n  .description {\n    gap: var( --size-medium );\n    max-width: 80%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentArea": `contentArea_FiMYL`,
	"container": `container_E6KkM`,
	"billingIconContainer": `billingIconContainer_PN3z_`,
	"billingIcon": `billingIcon_GtaLk`,
	"description": `description_outkt`,
	"buttonContainer": `buttonContainer_T1dTJ`
};
export default ___CSS_LOADER_EXPORT___;
